import { render, staticRenderFns } from "./recommend_tabs.vue?vue&type=template&id=224c64d9&scoped=true&"
import script from "./recommend_tabs.vue?vue&type=script&lang=ts&"
export * from "./recommend_tabs.vue?vue&type=script&lang=ts&"
import style0 from "./recommend_tabs.vue?vue&type=style&index=0&id=224c64d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224c64d9",
  null
  
)

export default component.exports